<template>
  <div v-if="allow" class="pa-2 pt-3 text-center" style="width: 105px;">
    <v-btn
      fab
      outlined
      :to="path"
      :class="getTheme() == 'dark' ? 'primary--text' : 'primary--text'"
    >
      <v-badge v-if="badgeIcon" color="secondary">
        <template v-slot:badge>
          <v-icon class="pa-0 ma-0" style="width:12px; height: 12px;" x-small>{{
            badgeIcon
          }}</v-icon>
        </template>
        <v-icon>{{ icon }}</v-icon>
      </v-badge>
      <v-icon v-else>{{ icon }}</v-icon>
    </v-btn>
    <div style="margin-top: 5px;">{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: "home-menu-admin-btn",
  props: {
    path: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    allow: {
      type: Boolean,
      required: true
    },
    badgeIcon: {
      type: String,
      required: false
    }
  }
};
</script>

<style scoped>
</style>